(() => {
  'use strict';
  if (customElements.get('fs-size-product')) return;

  const safeImage = (value, base) => {
    try {
      const url = new URL(value || '', base);
      return value && url.protocol === 'https:' ? url.href : '';
    } catch (_) { return ''; }
  };
  const allowedTags = new Set(['P', 'DIV', 'SECTION', 'SPAN', 'STRONG', 'B', 'EM', 'I', 'U', 'S', 'BR', 'HR', 'UL', 'OL', 'LI', 'DL', 'DT', 'DD', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'TABLE', 'THEAD', 'TBODY', 'TFOOT', 'TR', 'TH', 'TD', 'CAPTION', 'FIGURE', 'FIGCAPTION', 'IMG', 'BLOCKQUOTE', 'SUP', 'SUB']);
  const blockedTags = new Set(['SCRIPT', 'STYLE', 'IFRAME', 'OBJECT', 'EMBED', 'FORM', 'INPUT', 'SELECT', 'TEXTAREA', 'BUTTON', 'TEMPLATE', 'NOSCRIPT', 'SVG', 'MATH', 'LINK', 'META']);

  class FsSizeProduct extends HTMLElement {
    connectedCallback() {
      if (this.connected) return;
      this.owner = this.closest('[data-fs-size-shop]');
      this.dialog = this.querySelector('dialog');
      if (!this.owner || this.parentElement !== this.owner || !this.dialog) return;
      this.connected = true;
      this.closeButton = this.el('close');
      this.variantSelect = this.el('variant');
      this.addButton = this.el('add');
      this.variants = [];
      this.onVariantChange = () => { this.explicitVariantId = this.variantSelect.value; this.addedVariantId = ''; this.el('cart-status').textContent = ''; this.syncPurchase(); };
      this.variantSelect.addEventListener('change', this.onVariantChange);
      this.image = this.el('image');
      this.photos = [];
      this.carousel = this.querySelector('.fs-size-product__photo');
      this.carousel.setAttribute('data-fs-size-detail-carousel', '');
      this.noImageText = this.el('no-image').textContent;
      this.onPhotoScroll = () => {
        const width = this.carousel.clientWidth;
        if (!width || !this.photos.length) return;
        const index = Math.max(0, Math.min(this.photos.length - 1, Math.round(this.carousel.scrollLeft / width)));
        this.selectPhoto(index);
      };
      this.onOwnerClick = (event) => {
        const opener = event.target.closest('[data-fs-size-product]');
        if (!opener || !this.owner.contains(opener)) return;
        event.preventDefault();
        this.open(opener);
      };
      this.onClick = (event) => {
        const close = event.target.closest('[data-fs-size-detail-close], [data-fs-size-detail-back]');
        if (close) this.close();
        if (event.target.closest('[data-fs-size-detail-add]')) this.addToCart();
        const photo = event.target.closest('[data-fs-size-detail-photo]');
        if (photo) this.showPhoto(Number(photo.dataset.fsSizeDetailPhoto));
        if (event.target.closest('[data-fs-size-detail-prev]')) this.showPhoto(this.photoIndex - 1);
        if (event.target.closest('[data-fs-size-detail-next]')) this.showPhoto(this.photoIndex + 1);
        if (event.target.closest('[data-fs-size-detail-retry]')) this.open(this.opener);
        if (event.target === this.dialog && this.backdropStart) {
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.close();
        }
        this.backdropStart = false;
      };
      this.onPointerDown = (event) => { this.backdropStart = event.target === this.dialog; };
      this.onCancel = (event) => { event.preventDefault(); this.close(); };
      this.onClose = () => {
        this.controller?.abort();
        this.unlockScroll();
        const opener = this.opener?.isConnected ? this.opener : this.owner.querySelector('[data-fs-size-product="' + this.productId + '"]');
        (opener || this.owner.querySelector('[data-fs-size-shop-product], button, a[href]'))?.focus({ preventScroll: true });
      };
      this.onKeyDown = (event) => {
        if (event.key === 'Escape') { event.preventDefault(); this.close(); return; }
        if (event.key !== 'Tab') return;
        const focusable = Array.from(this.dialog.querySelectorAll('button:not([disabled]), select:not([disabled]), [href], summary, [tabindex]:not([tabindex="-1"])')).filter((node) => !node.closest('[hidden]') && node.getClientRects().length);
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        const current = this.ownerDocument.activeElement;
        if (!first) { event.preventDefault(); this.closeButton.focus(); return; }
        if (event.shiftKey && (current === first || !this.dialog.contains(current))) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && (current === last || !this.dialog.contains(current))) { event.preventDefault(); first.focus(); }
      };
      this.onHistory = () => this.close();
      window.addEventListener('popstate', this.onHistory);
      this.owner.addEventListener('click', this.onOwnerClick);
      this.owner.setAttribute('data-fs-size-product-ready', '');
      this.carousel.addEventListener('scroll', this.onPhotoScroll, { passive: true });
      if (typeof ResizeObserver === 'function') {
        this.carouselWidth = 0;
        this.carouselObserver = new ResizeObserver(() => {
          const width = this.carousel.clientWidth;
          if (width > 0 && width !== this.carouselWidth) {
            this.carouselWidth = width;
            this.alignPhoto();
          }
        });
        this.carouselObserver.observe(this.carousel);
      }
      this.dialog.addEventListener('click', this.onClick);
      this.dialog.addEventListener('pointerdown', this.onPointerDown);
      this.dialog.addEventListener('cancel', this.onCancel);
      this.dialog.addEventListener('close', this.onClose);
      this.dialog.addEventListener('keydown', this.onKeyDown);

    }

    disconnectedCallback() {
      this.controller?.abort();
      this.unlockScroll();
      this.owner?.removeEventListener('click', this.onOwnerClick);
      this.variantSelect?.removeEventListener('change', this.onVariantChange);
      this.owner?.removeAttribute('data-fs-size-product-ready');
      window.removeEventListener('popstate', this.onHistory);
      this.carousel?.removeEventListener('scroll', this.onPhotoScroll);
      this.carouselObserver?.disconnect();
      if (this.dialog) {
        this.dialog.removeEventListener('click', this.onClick);
        this.dialog.removeEventListener('pointerdown', this.onPointerDown);
        this.dialog.removeEventListener('cancel', this.onCancel);
        this.dialog.removeEventListener('close', this.onClose);
        this.dialog.removeEventListener('keydown', this.onKeyDown);
        if (this.dialog.open) this.dialog.close();
      }
      this.connected = false;
    }

    el(name) { return this.querySelector('[data-fs-size-detail-' + name + ']'); }
    label(name) { return this.dataset[name] || ''; }
    money(value) {
      return new Intl.NumberFormat(this.dataset.locale || 'en', { style: 'currency', currency: this.dataset.currency || 'PKR' }).format(value / 100);
    }
    close() { if (this.dialog.open) this.dialog.close(); }
    lockScroll() {
      if (this.scrollLock) return;
      const body = this.ownerDocument.body;
      const html = this.ownerDocument.documentElement;
      this.scrollLock = { body: body.style.overflow, html: html.style.overflow };
      body.style.overflow = 'hidden';
      html.style.overflow = 'hidden';
    }
    unlockScroll() {
      if (!this.scrollLock) return;
      this.ownerDocument.body.style.overflow = this.scrollLock.body;
      this.ownerDocument.documentElement.style.overflow = this.scrollLock.html;
      this.scrollLock = null;
    }
    productURL(product, opener) {
      const url = new URL(product.url || opener.dataset.productUrl || '', location.origin);
      if (url.origin !== location.origin || !/\/products\/[^/]+\/?$/.test(url.pathname)) throw new Error('Invalid product URL');
      url.pathname = url.pathname.replace(/\/$/, '');
      url.search = '';
      url.hash = '';
      const preview = this.dataset.previewThemeId;
      if (preview && /^\d+$/.test(preview)) url.searchParams.set('preview_theme_id', preview);
      return url;
    }
    async request(url, signal, format) {
      const response = await fetch(url.href, { method: 'GET', credentials: 'same-origin', cache: 'no-store', signal, headers: { Accept: format === 'json' ? 'application/json' : 'text/html' } });
      if (!response.ok) throw new Error('Product details unavailable');
      return format === 'json' ? response.json() : response.text();
    }
    async open(opener) {
      if (!opener || typeof this.dialog.showModal !== 'function') return;
      const productId = String(opener.dataset.fsSizeProduct || '');
      if (!/^\d+$/.test(productId)) return;
      const product = { id: productId, title: opener.dataset.productTitle || '', url: opener.dataset.productUrl || '', image: opener.dataset.productImage || '' };
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.opener = opener;
      this.productId = productId;
      this.resetPurchase();
      this.el('title').textContent = product.title;
      this.el('price').textContent = '';
      this.el('status').textContent = this.label('labelLoading');
      this.el('retry').hidden = true;
      this.el('empty').hidden = true;
      this.el('description').hidden = true;
      this.el('description-content').replaceChildren();
      this.el('details').replaceChildren();
      this.el('link').removeAttribute('href');
      this.el('content').setAttribute('aria-busy', 'true');
      this.descriptionLoaded = false;
      this.detailsLoaded = false;
      this.setPhotos(product.image ? [{ src: product.image, alt: product.title }] : []);
      if (!this.dialog.open) {
        this.dialog.showModal();
        this.lockScroll();
      }
      this.alignPhoto();
      this.el('scroll').scrollTop = 0;
      this.closeButton.focus({ preventScroll: true });
      let timer;
      try {
        const url = this.productURL(product, opener);
        this.el('link').href = url.href;
        const jsonURL = new URL(url.href);
        jsonURL.pathname += '.js';
        const controller = this.controller;
        timer = setTimeout(() => controller.abort(), 15000);
        const current = () => !signal.aborted && this.dialog.open && this.controller === controller;
        const results = await Promise.allSettled([
          this.request(jsonURL, signal, 'json').then((data) => {
            if (!current()) return;
            if (!data || String(data.id) !== productId || !Array.isArray(data.images) || !Array.isArray(data.variants)) throw new Error('Mismatched product');
            this.el('title').textContent = String(data.title || product.title);
            const photoMeta = new Map((data.media || []).filter((media) => media.media_type === 'image' && media.preview_image?.src).map((media) => [safeImage(media.preview_image.src, url), media.alt]));
            this.setPhotos(data.images.map((image) => {
              const src = typeof image === 'string' ? image : image.src;
              return { src, alt: (typeof image === 'object' && image.alt) || photoMeta.get(safeImage(src, url)) || data.title || product.title };
            }));
            this.setVariants(data);
            if (data.description) this.setDescription(data.description, url);
          }),
          this.request(url, signal, 'html').then((html) => {
            if (!current()) return;
            const page = new DOMParser().parseFromString(html, 'text/html');
            const main = page.querySelector('product-info[id^="MainProduct-"]');
            if (!main || String(main.dataset.productId) !== productId) throw new Error('Mismatched product details');
            if (!this.descriptionLoaded) {
              const description = main.querySelector('.product__description');
              if (description) this.setDescription(description.innerHTML, url);
            }
            const blocks = [];
            main.querySelectorAll('.product__accordion').forEach((block) => {
              const title = block.querySelector('.accordion__title')?.textContent.trim();
              const content = block.querySelector('.accordion__content');
              if (title && content) blocks.push({ title, content });
            });
            main.querySelectorAll('.product-popup-modal__content-info').forEach((content) => {
              const heading = content.querySelector('h1, h2, h3');
              const title = heading?.textContent.trim();
              if (!title) return;
              heading.remove();
              blocks.push({ title, content });
            });
            const seen = new Set();
            blocks.forEach(({ title, content }) => {
              const key = title + ':' + content.textContent.trim();
              if (seen.has(key)) return;
              seen.add(key);
              const fragment = this.sanitize(content, url);
              if (!fragment.textContent.trim() && !fragment.querySelector('img')) return;
              const details = this.ownerDocument.createElement('details');
              details.className = 'fs-size-product__detail';
              const summary = this.ownerDocument.createElement('summary');
              summary.textContent = title;
              const body = this.ownerDocument.createElement('div');
              body.className = 'fs-size-product__rich';
              body.append(fragment);
              details.append(summary, body);
              this.el('details').append(details);
            });
            this.detailsLoaded = true;
          })
        ]);
        if (!this.dialog.open || this.controller !== controller) return;
        const failed = results.some((result) => result.status === 'rejected');
        this.el('status').textContent = failed ? this.label('labelError') : '';
        this.el('retry').hidden = !failed;
        this.el('empty').hidden = failed || this.descriptionLoaded || Boolean(this.el('details').children.length);
      } catch (_) {
        if (signal.aborted || !this.dialog.open) return;
        this.el('status').textContent = this.label('labelError');
        this.el('retry').hidden = false;
      } finally {
        clearTimeout(timer);
        if (this.controller?.signal === signal) this.el('content').setAttribute('aria-busy', 'false');
      }
    }
    normalizedSize(value) {
      const text = String(value || '').trim();
      const key = text.toLowerCase().replace(/[\s_-]+/g, '');
      const sizes = { extrasmall: 'XS', xsmall: 'XS', xs: 'XS', small: 'S', s: 'S', medium: 'M', m: 'M', large: 'L', l: 'L', extralarge: 'XL', xlarge: 'XL', xl: 'XL', extraextralarge: 'XXL', xxlarge: 'XXL', xxl: 'XXL', '2xl': 'XXL', xxxlarge: '3XL', xxxl: '3XL', '3xl': '3XL' };
      return sizes[key] || text;
    }
    resetPurchase() {
      this.variants = [];
      this.productData = null;
      this.explicitVariantId = '';
      this.addedVariantId = '';
      this.variantSelect.replaceChildren();
      this.variantSelect.disabled = true;
      this.addButton.disabled = true;
      this.addButton.textContent = this.label('labelAdd');
      this.el('purchase').hidden = true;
      this.el('availability').textContent = '';
      this.el('cart-status').textContent = this.cartUncertain ? this.label('labelCartUncertain') : '';
      this.el('cart-link').hidden = !this.cartUncertain;
    }
    variantOptions(variant) {
      return Array.isArray(variant.options) ? variant.options : [variant.option1, variant.option2, variant.option3].filter((value) => value != null);
    }
    variantSupported(variant) {
      if (!variant || this.productData?.requires_selling_plan || variant.requires_selling_plan || variant.requires_components || this.productData?.requires_components) return false;
      const rule = variant.quantity_rule;
      return !rule || ((rule.min == null || rule.min <= 1) && (rule.max == null || rule.max >= 1) && (rule.increment == null || rule.increment === 1));
    }
    variantLabel(variant) {
      const options = this.variantOptions(variant);
      const parts = this.visibleAxes.map((index) => index === this.sizeIndex ? this.normalizedSize(options[index]) : String(options[index] || '')).filter(Boolean);
      return parts.join(' / ') || this.label('labelSingleOption');
    }
    priceRange() {
      const prices = this.variants.map((variant) => variant.price).filter((price) => Number.isSafeInteger(price) && price >= 0);
      if (!prices.length) return '';
      const min = Math.min(...prices), max = Math.max(...prices);
      return this.money(min) + (max > min ? ' – ' + this.money(max) : '');
    }
    setVariants(data) {
      this.productData = data;
      this.variants = data.variants.filter((variant) => /^\d+$/.test(String(variant.id)) && Number.isSafeInteger(variant.price) && variant.price >= 0);
      const options = Array.isArray(data.options) ? data.options : [];
      this.sizeIndex = options.findIndex((option) => /^(size|sizes)$/i.test(String(typeof option === 'string' ? option : option?.name || '').trim()));
      this.visibleAxes = options.map((_, index) => index).filter((index) => index === this.sizeIndex || new Set(this.variants.map((variant) => this.variantOptions(variant)[index])).size > 1);
      if (!this.visibleAxes.length && this.variants.length > 1) this.visibleAxes = [0];
      this.el('variant-label').textContent = this.label(this.sizeIndex >= 0 ? 'labelSize' : 'labelOption');
      const placeholder = this.ownerDocument.createElement('option');
      placeholder.value = '';
      placeholder.textContent = this.label(this.sizeIndex >= 0 ? 'labelChooseSize' : 'labelChooseOption');
      placeholder.selected = true;
      this.variantSelect.replaceChildren(placeholder);
      this.variants.forEach((variant) => {
        const option = this.ownerDocument.createElement('option');
        option.value = String(variant.id);
        option.textContent = this.variantLabel(variant);
        option.disabled = variant.available !== true || !this.variantSupported(variant);
        this.variantSelect.append(option);
      });
      this.explicitVariantId = '';
      this.variantSelect.value = '';
      this.el('purchase').hidden = false;
      this.syncPurchase();
    }
    syncPurchase() {
      const variant = this.variants.find((item) => String(item.id) === this.explicitVariantId && this.variantSelect.value === this.explicitVariantId);
      const blocked = this.productData?.requires_selling_plan || this.productData?.requires_components;
      const added = Boolean(variant && String(variant.id) === this.addedVariantId);
      this.variantSelect.disabled = Boolean(blocked || this.cartPending || this.cartUncertain || !this.variants.length);
      this.addButton.disabled = Boolean(!variant || variant.available !== true || !this.variantSupported(variant) || this.cartPending || this.cartUncertain || added);
      this.addButton.textContent = this.label(this.cartPending ? 'labelAdding' : added ? 'labelAdded' : 'labelAdd');
      this.el('price').textContent = variant ? this.money(variant.price) : this.priceRange();
      this.el('availability').textContent = blocked ? this.label('labelUnsupported') : variant ? this.label(variant.available === true ? 'labelAvailable' : 'labelSoldOut') : '';
      this.el('purchase').setAttribute('aria-busy', String(Boolean(this.cartPending)));
      if (this.cartUncertain) {
        this.el('cart-status').textContent = this.label('labelCartUncertain');
        this.el('cart-link').hidden = false;
      }
    }
    cartURL(add) {
      const url = new URL(add ? this.dataset.cartAddUrl : this.dataset.cartUrl, location.origin);
      const pattern = add ? /\/cart\/add\.js$/ : /\/cart\/?$/;
      if (url.origin !== location.origin || !pattern.test(url.pathname)) throw new Error('Invalid cart route');
      url.search = '';
      url.hash = '';
      if (!add && /^\d+$/.test(this.dataset.previewThemeId || '')) url.searchParams.set('preview_theme_id', this.dataset.previewThemeId);
      return url;
    }
    async refreshCartCount() {
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 8000);
      try {
        const url = this.cartURL(false);
        url.search = '';
        url.pathname = url.pathname.replace(/\/$/, '') + '.js';
        const data = await this.request(url, controller.signal, 'json');
        if (!Number.isSafeInteger(data.item_count) || data.item_count < 0) return;
        const icon = this.ownerDocument.getElementById('cart-icon-bubble');
        if (!icon) return;
        let bubble = icon.querySelector('.cart-count-bubble');
        if (!data.item_count) { bubble?.remove(); return; }
        if (!bubble) {
          bubble = this.ownerDocument.createElement('div');
          bubble.className = 'cart-count-bubble';
          icon.append(bubble);
        }
        const count = this.ownerDocument.createElement('span');
        count.setAttribute('aria-hidden', 'true');
        count.textContent = String(data.item_count);
        count.hidden = data.item_count >= 100;
        const description = this.ownerDocument.createElement('span');
        description.className = 'visually-hidden';
        description.textContent = this.label('labelCartCount').replace('{count}', String(data.item_count));
        bubble.replaceChildren(count, description);
      } catch (_) {
        // The add is already confirmed. A count refresh failure must not repeat it.
      } finally { clearTimeout(timer); }
    }
    async refreshCartDrawer() {
      const drawer = this.ownerDocument.querySelector('cart-drawer');
      if (!drawer || drawer.classList.contains('active')) return;
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 8000);
      try {
        const url = this.cartURL(false);
        url.searchParams.set('section_id', 'cart-drawer');
        const html = await this.request(url, controller.signal, 'html');
        const source = new DOMParser().parseFromString(html, 'text/html').querySelector('cart-drawer');
        const target = drawer.querySelector('#CartDrawer');
        const replacement = source?.querySelector('#CartDrawer');
        if (!source || !target || !replacement || drawer.classList.contains('active')) return;
        // Refresh the native section without renderContents(), which opens the drawer.
        replacement.querySelectorAll('script').forEach((script) => script.remove());
        target.replaceWith(this.ownerDocument.importNode(replacement, true));
        drawer.classList.toggle('is-empty', source.classList.contains('is-empty'));
        drawer.querySelector('#CartDrawer-Overlay')?.addEventListener('click', () => drawer.close?.());
      } catch (_) {
        // View cart remains a normal link to the server-rendered cart page.
      } finally { clearTimeout(timer); }
    }
    async addToCart() {
      if (this.cartPending || this.cartUncertain) return;
      const variant = this.variants.find((item) => String(item.id) === this.explicitVariantId && this.variantSelect.value === this.explicitVariantId);
      if (!variant) {
        this.el('cart-status').textContent = this.label(this.sizeIndex >= 0 ? 'labelChooseSize' : 'labelChooseOption');
        this.variantSelect.focus();
        return;
      }
      if (variant.available !== true || !this.variantSupported(variant) || String(variant.id) === this.addedVariantId) return;
      const session = this.controller;
      let addURL;
      try {
        addURL = this.cartURL(true);
        this.el('cart-link').href = this.cartURL(false).href;
      } catch (_) {
        this.el('cart-status').textContent = this.label('labelCartError');
        return;
      }
      this.cartPending = true;
      this.el('cart-status').textContent = this.label('labelAdding');
      this.syncPurchase();
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 20000);
      try {
        // Public shopping choice only. No form, frame, estimate, properties or plan data is read.
        const response = await fetch(addURL.href, {
          method: 'POST', credentials: 'same-origin', signal: controller.signal,
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] })
        });
        let data;
        try { data = await response.json(); } catch (_) { throw new Error('Unconfirmed cart result'); }
        if (!response.ok) {
          if (response.status === 422 || response.status === 400) {
            if (this.controller === session) {
              this.el('cart-status').textContent = typeof data.description === 'string' ? data.description : this.label('labelCartError');
              this.el('cart-link').hidden = false;
            }
            return;
          }
          throw new Error('Unconfirmed cart result');
        }
        const added = Array.isArray(data.items) ? data.items : [data];
        if (added.length !== 1 || String(added[0]?.variant_id || added[0]?.id) !== String(variant.id) || !(Number(added[0]?.quantity) >= 1)) throw new Error('Unexpected cart result');
        if (this.controller === session) {
          this.addedVariantId = String(variant.id);
          this.el('cart-status').textContent = this.label('labelCartSuccess');
          this.el('cart-link').hidden = false;
        }
        await Promise.all([this.refreshCartCount(), this.refreshCartDrawer()]);
      } catch (_) {
        // An interrupted POST may already have succeeded. Never silently retry it.
        this.cartUncertain = true;
      } finally {
        clearTimeout(timer);
        this.cartPending = false;
        if (this.connected) this.syncPurchase();
      }
    }
    setPhotos(photos) {
      this.photos = photos.map((photo) => ({ ...photo, src: safeImage(photo.src, location.origin) })).filter((photo) => photo.src);
      this.photoImages = [];
      this.carousel.replaceChildren();
      this.photoIndex = 0;
      if (!this.photos.length) {
        const empty = this.ownerDocument.createElement('p');
        empty.dataset.fsSizeDetailNoImage = '';
        empty.textContent = this.noImageText;
        this.carousel.append(empty);
      }
      this.photos.forEach((photo, index) => {
        const slide = this.ownerDocument.createElement('div');
        slide.className = 'fs-size-product__slide';
        slide.dataset.fsSizeDetailSlide = String(index);
        slide.setAttribute('role', 'group');
        slide.setAttribute('aria-label', this.photoLabel(index));
        const img = this.ownerDocument.createElement('img');
        img.src = photo.src;
        img.alt = photo.alt || this.el('title').textContent;
        img.width = 700;
        img.height = 875;
        img.draggable = false;
        const fallback = this.ownerDocument.createElement('p');
        fallback.dataset.fsSizeDetailNoImage = '';
        fallback.textContent = this.noImageText;
        fallback.hidden = true;
        img.addEventListener('error', () => { img.hidden = true; fallback.hidden = false; }, { once: true });
        slide.append(img, fallback);
        this.carousel.append(slide);
        this.photoImages.push(img);
      });
      const thumbs = this.el('thumbs');
      thumbs.replaceChildren();
      this.photos.forEach((photo, index) => {
        const button = this.ownerDocument.createElement('button');
        button.type = 'button';
        button.dataset.fsSizeDetailPhoto = String(index);
        button.setAttribute('aria-label', this.photoLabel(index));
        const img = this.ownerDocument.createElement('img');
        img.src = photo.src;
        img.alt = '';
        img.width = 72;
        img.height = 90;
        img.loading = 'lazy';
        button.append(img);
        thumbs.append(button);
      });
      thumbs.hidden = this.photos.length < 2;
      this.el('photo-controls').hidden = this.photos.length < 2;
      this.showPhoto(0);
    }
    photoLabel(index) { return this.label('labelPhoto').replace('{current}', String(index + 1)).replace('{total}', String(this.photos.length)); }
    selectPhoto(index) {
      if (!this.photos.length) {
        this.image = null;
        this.el('counter').textContent = '';
        return;
      }
      this.photoIndex = Math.max(0, Math.min(this.photos.length - 1, index));
      this.photoImages.forEach((image, position) => {
        if (position === this.photoIndex) image.setAttribute('data-fs-size-detail-image', '');
        else image.removeAttribute('data-fs-size-detail-image');
      });
      this.image = this.photoImages[this.photoIndex];
      this.el('counter').textContent = this.photoLabel(this.photoIndex);
      this.el('thumbs').querySelectorAll('button').forEach((button, position) => button.setAttribute('aria-pressed', String(position === this.photoIndex)));
    }
    alignPhoto() {
      const width = this.carousel.clientWidth;
      if (!width || !this.photos.length) return;
      const left = width * this.photoIndex;
      if (typeof this.carousel.scrollTo === 'function') this.carousel.scrollTo({ left, behavior: 'auto' });
      else this.carousel.scrollLeft = left;
    }
    showPhoto(index) {
      const next = this.photos.length ? (index + this.photos.length) % this.photos.length : 0;
      this.selectPhoto(next);
      this.alignPhoto();
    }
    setDescription(html, base) {
      const source = new DOMParser().parseFromString(html, 'text/html');
      const fragment = this.sanitize(source.body, base);
      if (!fragment.textContent.trim() && !fragment.querySelector('img')) return;
      this.el('description-content').replaceChildren(fragment);
      this.el('description').hidden = false;
      this.descriptionLoaded = true;
    }
    sanitize(source, base) {
      const output = this.ownerDocument.createDocumentFragment();
      const copy = (node, parent) => {
        if (node.nodeType === 3) { parent.append(this.ownerDocument.createTextNode(node.textContent)); return; }
        if (node.nodeType !== 1 || blockedTags.has(node.tagName)) return;
        if (!allowedTags.has(node.tagName)) { Array.from(node.childNodes).forEach((child) => copy(child, parent)); return; }
        const tag = /^H[1-6]$/.test(node.tagName) ? 'h4' : node.tagName.toLowerCase();
        const element = this.ownerDocument.createElement(tag);
        if (tag === 'img') {
          const src = safeImage(node.getAttribute('src') || node.getAttribute('data-src'), base);
          if (!src) return;
          element.src = src;
          element.alt = node.getAttribute('alt') || '';
          element.loading = 'lazy';
          element.decoding = 'async';
          ['width', 'height'].forEach((attribute) => {
            const value = node.getAttribute(attribute);
            if (/^\d{1,5}$/.test(value || '')) element.setAttribute(attribute, value);
          });
        }
        if (tag === 'td' || tag === 'th') {
          ['colspan', 'rowspan'].forEach((attribute) => {
            const value = node.getAttribute(attribute);
            if (/^[1-9]\d?$/.test(value || '')) element.setAttribute(attribute, value);
          });
          if (['row', 'col', 'rowgroup', 'colgroup'].includes(node.getAttribute('scope'))) element.setAttribute('scope', node.getAttribute('scope'));
        }
        Array.from(node.childNodes).forEach((child) => copy(child, element));
        parent.append(element);
      };
      Array.from(source.childNodes).forEach((node) => copy(node, output));
      return output;
    }
  }
  customElements.define('fs-size-product', FsSizeProduct);
})();
